module.exports = __webpack_public_path__ + "static/media/2.2bcbd3d9.jpg";